import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  useTheme,
  Avatar,
  Divider,
} from "@mui/material";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";

const features = [
  {
    icon: <MedicalServicesIcon fontSize="large" />,
    title: "Ampla Cobertura",
    description:
      "Planos com cobertura completa para consultas, exames, internações e procedimentos cirúrgicos.",
  },
  {
    icon: <LocalHospitalIcon fontSize="large" />,
    title: "Rede Credenciada",
    description:
      "Acesso aos melhores hospitais, clínicas e laboratórios do Brasil.",
  },
  {
    icon: <HealthAndSafetyIcon fontSize="large" />,
    title: "Medicina Preventiva",
    description:
      "Programas de prevenção e promoção à saúde para uma vida mais saudável.",
  },
  {
    icon: <AccessTimeIcon fontSize="large" />,
    title: "Atendimento 24h",
    description:
      "Suporte e atendimento disponíveis 24 horas por dia, 7 dias por semana.",
  },
  {
    icon: <MonetizationOnIcon fontSize="large" />,
    title: "Melhor Custo-Benefício",
    description:
      "Planos com valores competitivos e benefícios exclusivos para você e sua família.",
  },
  {
    icon: <FamilyRestroomIcon fontSize="large" />,
    title: "Planos Familiares",
    description:
      "Soluções personalizadas para toda família com condições especiais.",
  },
];

export const FeaturesSection = () => {
  const theme = useTheme();

  return (
    <Box
      id="benefícios"
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h6"
            component="p"
            color="secondary"
            sx={{ fontWeight: 600, mb: 2 }}
          >
            BENEFÍCIOS EXCLUSIVOS
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
              color: theme.palette.text.primary,
            }}
          >
            Por que escolher nossos planos?
          </Typography>
          <Divider
            sx={{
              width: "80px",
              height: "4px",
              backgroundColor: theme.palette.secondary.main,
              mx: "auto",
              my: 3,
              borderRadius: "2px",
            }}
          />
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              maxWidth: "800px",
              mx: "auto",
            }}
          >
            Oferecemos soluções completas em planos de saúde com as principais
            operadoras do mercado, garantindo o melhor custo-benefício para sua
            proteção.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "12px",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                  },
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                  overflow: "visible",
                }}
              >
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Avatar
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      width: 60,
                      height: 60,
                      mb: 2,
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                      transform: "translateY(-20px)",
                      ml: 1,
                    }}
                  >
                    {feature.icon}
                  </Avatar>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h3"
                    sx={{ fontWeight: 600, mb: 1 }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
